import { renderSlot as _renderSlot, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/icon_add.png'


const _withScopeId = n => (_pushScopeId("data-v-2482ea92"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dept-select" }
const _hoisted_2 = {
  key: 1,
  class: "user-select"
}
const _hoisted_3 = { class: "user-list" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "ellipsis" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "选择部门", -1))
const _hoisted_9 = { class: "dept-select-modal__bd" }
const _hoisted_10 = { class: "user-select__left" }
const _hoisted_11 = { class: "user-select__left__hd" }
const _hoisted_12 = { class: "user-select__left__bd" }
const _hoisted_13 = { class: "user-select__right" }
const _hoisted_14 = { class: "user-select__right__hd" }
const _hoisted_15 = { class: "text-grey" }
const _hoisted_16 = { class: "user-select__right__bd" }
const _hoisted_17 = { class: "selected-user__icon" }
const _hoisted_18 = ["onClick"]

export function render(_ctx, _cache) {
  const _component_a_tag = _resolveComponent("a-tag")
  const _component_department_tree_select = _resolveComponent("department-tree-select")
  const _component_ant_icon = _resolveComponent("ant-icon")
  const _component_a_tree = _resolveComponent("a-tree")
  const _component_a_modal = _resolveComponent("a-modal")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.$slots.default)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => (_ctx.showModal && _ctx.showModal(...args)), ["stop"]))
        }, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass(["user-content", _ctx.isError ? 'is-error': ''])
          }, [
            _createElementVNode("div", _hoisted_3, [
              (!_ctx.selectedDepts.length)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, "请选择"))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.selectedDepts, (user) => {
                    return (_openBlock(), _createBlock(_component_a_tag, {
                      key: user.id,
                      closable: "",
                      color: "blue",
                      onClose: _withModifiers($event => (_ctx.deleteSelectedDept(user.id)), ["prevent"])
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_5, _toDisplayString(user.name?.length > 20 ? user.name?.slice(0, 15) + "..." : user.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClose"]))
                  }), 128))
            ]),
            (_ctx.maxCount === 0 || _ctx.selectedDepts.length < _ctx.maxCount)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "add-icon",
                  type: "link",
                  onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.showModal && _ctx.showModal(...args)))
                }, _hoisted_7))
              : _createCommentVNode("", true)
          ], 2)
        ])),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[3] || (_cache[3] = $event => ((_ctx.visible) = $event)),
      centered: true,
      keyboard: false,
      "mask-closable": false,
      class: "dept-select-modal",
      width: "520px",
      onCancel: _ctx.closeModal,
      onOk: _ctx.ok
    }, {
      title: _withCtx(() => [
        _hoisted_8
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_department_tree_select, {
                value: _ctx.userSearchId,
                "onUpdate:value": _cache[2] || (_cache[2] = $event => ((_ctx.userSearchId) = $event)),
                class: "w100",
                placeholder: "输入部门名称关键字",
                onSelect: _ctx.onDeptTreeSelect
              }, null, 8, ["value", "onSelect"])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_a_tree, {
                expandedKeys: _ctx.expandedKeys,
                fieldNames: { children: 'children', title: 'name', key: 'id' },
                "tree-data": _ctx.treeData,
                "show-icon": "",
                onSelect: _ctx.addTempDept
              }, {
                department: _withCtx(() => [
                  _createVNode(_component_ant_icon, { type: "ForkOutlined" })
                ]),
                _: 1
              }, 8, ["expandedKeys", "tree-data", "onSelect"])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("span", _hoisted_15, "已选择的部门（" + _toDisplayString(_ctx.tempDepts.length) + "个）", 1)
            ]),
            _createElementVNode("div", _hoisted_16, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tempDepts, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.id,
                  class: "selected-user"
                }, [
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_ant_icon, { type: "DeptOutlined" })
                  ]),
                  _createElementVNode("span", null, _toDisplayString(item.name), 1),
                  _createElementVNode("div", {
                    class: "selected-user__delete",
                    onClick: $event => (_ctx.deleteTempDept(item.id))
                  }, [
                    _createVNode(_component_ant_icon, { type: "CloseCircleOutlined" })
                  ], 8, _hoisted_18)
                ]))
              }), 128))
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "onCancel", "onOk"])
  ]))
}